// --- API Hooks ---
import {
  useGetCompareListQuery,
  useGetCompareItemsDataQuery,
  useToggleCompareItemMutation,
  useRemoveCompareItemMutation,
} from "../templates/ecommerce/compare/api/compareApi";

// --- Custom Hooks ---
import { useRemoveFromCompare } from "../templates/ecommerce/compare/hooks/useRemoveFromCompare";
import { useToggleCompareItem } from "../templates/ecommerce/compare/hooks/useToggleCompareItem";

// --- Selectors ---
import {
  selectCompareItems,
  selectCompareCount,
  selectIsInCompare,
} from "../templates/ecommerce/compare/compareSelectors";

// --- UI Components ---
import CompareToggleButton from "../templates/ecommerce/compare/components/common/CompareToggleButton";
import ComparePage from "../templates/ecommerce/compare/components/Page/ComparePage";
import CompareTable from "../templates/ecommerce/compare/components/Page/CompareTable/CompareTable";

export const compare = {
  // 1. API Data Fetching
  api: {
    useGetCompareListQuery,
    useGetCompareItemsDataQuery,
    useToggleCompareItemMutation,
    useRemoveCompareItemMutation,
  },

  // 2. Logic Hooks
  hooks: {
    useRemoveFromCompare,
    useToggleCompareItem,
  },

  // 3. UI Components
  components: {
    CompareToggleButton,
    ComparePage,
    CompareTable,
  },

  // 4. Selectors
  selectors: {
    selectCompareItems,
    selectCompareCount,
    selectIsInCompare,
  },
};
